import React, { useEffect, useState } from 'react';
import { dropdownsStyle } from './styles';
import { useModal } from 'utils';
import { InactiveModal, NotError } from 'components';
import { toast } from 'react-toastify';

export const UserInputsDropdown = ({
    dropdownOptions = [],
    onPass,
    selected,
    actionType,
    type,
    disableRow = () => {},
    notifyMessage,
    styles = {},
}) => {
    const classes = dropdownsStyle();
    const [dropdownIsShown, setDropdownIsShown] = useState(false);
    const [current, setCurrent] = useState({});
    const { open } = useModal();

    useEffect(() => {
        if (selected) {
            const currentSelected = dropdownOptions?.find((i) => i?.id === selected);
            setCurrent(currentSelected);
        }
    }, [selected]);

    function chooseOptionHandler(option) {
        if (option?.id === selected) return setDropdownIsShown(false);
        if (option?.message) {
            open(
                <InactiveModal
                    actionType={actionType}
                    handleSave={(item) => {
                        onPass && onPass({ ...item, status: option?.id });
                        setCurrent(option);
                        setDropdownIsShown(false);
                    }}
                    name={type}
                />
            );
        } else {
            onPass && onPass({ status: option?.id });
            setCurrent(option);
            setDropdownIsShown(false);
        }
    }

    return (
        <>
            {dropdownIsShown && <div className={classes.dropOverlayStyle} onClick={() => setDropdownIsShown(false)} />}
            <div className={`${classes.userDropStyle}`}>
                <div className={`dropdown-box ${dropdownIsShown ? 'focused' : ''}`}>
                    <div className="show-dropdown-box" onClick={() => setDropdownIsShown((prevState) => !prevState)} style={{ ...styles }}>
                        <h6
                            className={`dropdown-selected ${type === 'goalStatuses' ? classes.goalOptionStyle : classes.optionStyle} ${current?.id}`}
                        >
                            {current?.label ? current?.label : 'Not Set'}
                        </h6>
                        <i className={`${dropdownIsShown ? 'active' : ''}`} />
                    </div>
                    {dropdownIsShown && (
                        <ul className="dropdown-options">
                            {dropdownOptions?.map((option, index) => {
                                return (
                                    <li
                                        style={{ opacity: disableRow(option) ? 0.5 : 1 }}
                                        key={index}
                                        className={`${type === 'goalStatuses' ? classes.goalOptionStyle : classes.optionStyle} ${option?.id}`}
                                        onClick={() => {
                                            disableRow(option)
                                                ? notifyMessage && toast(<NotError type={'error'} errMessage={notifyMessage} />)
                                                : chooseOptionHandler(option);
                                        }}
                                    >
                                        <span className={`dropdown-option-title ${option?.id === selected?.id ? 'selected-title' : ''}`}>
                                            {option ? option?.label : 'Not Set'}
                                        </span>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>
            </div>
        </>
    );
};
